import { ToastContainer } from "@mercdev.com/mercurial-ui/overlays";
import { useOAuth2 } from "@mercdev.com/mercury-id-authorization";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SWRConfig } from "swr";

import App from "./components/App/App";
import { NotFoundScreen } from "./components/NotFoundScreen/NotFoundScreen";
import { apiClient, fetcher } from "./services/apiClient";

export const Root = () => {
  const { apiCall, isAuth } = useOAuth2();

  // With `enforceAccess` on the OAuth2Provider, this tree mounts only once
  // access is Granted, so `apiCall` is ready synchronously. Initialize the API
  // client during render — before children mount — so their first SWR request
  // can't race ahead of initialization (an uninitialized client throws, which
  // would flash the "service unavailable" error screen on reload).
  if (isAuth && apiCall) {
    apiClient.initialize(apiCall);
  }

  return (
    <SWRConfig value={{ fetcher, refreshInterval: 0 }}>
      <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <App />
                  <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    limit={3}
                  />
                </>
              }
            />
            <Route path="*" element={<NotFoundScreen />} />
          </Routes>
        </BrowserRouter>
      </DndProvider>
    </SWRConfig>
  );
};
